const tumliBaseURL = 'https://tumli.framer.website' as const;
const telegramBaseURL = 'https://t.me' as const;
const instagramBaseURL = 'https://www.instagram.com' as const;

export const URLs = {
  generate: {
    instagramProfile: (username: string) => `${URLs.instagram}/${username}` as const,
    shareTelegramBot: (url: string, text: string) =>
      `${URLs.telegram}/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}` as const,
    telegramMasterProfile: (username: string) => `${URLs.telegram}/${username}` as const,
    telegramUser: (botUsername: string) => `${URLs.telegram}/${botUsername}` as const,
  },

  instagram: instagramBaseURL,
  privacyPolicy: `${tumliBaseURL}/privacy` as const,
  telegram: telegramBaseURL,
  telegramBotFather: `${telegramBaseURL}/BotFather` as const,
  termsOfService: `${tumliBaseURL}/terms` as const,
} as const;
